"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAblyTokenDto = instanceOfAblyTokenDto;
exports.AblyTokenDtoFromJSON = AblyTokenDtoFromJSON;
exports.AblyTokenDtoFromJSONTyped = AblyTokenDtoFromJSONTyped;
exports.AblyTokenDtoToJSON = AblyTokenDtoToJSON;
exports.AblyTokenDtoToJSONTyped = AblyTokenDtoToJSONTyped;
/**
 * Check if a given object implements the AblyTokenDto interface.
 */
function instanceOfAblyTokenDto(value) {
    if (!('keyName' in value) || value['keyName'] === undefined)
        return false;
    if (!('capability' in value) || value['capability'] === undefined)
        return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined)
        return false;
    if (!('nonce' in value) || value['nonce'] === undefined)
        return false;
    if (!('mac' in value) || value['mac'] === undefined)
        return false;
    return true;
}
function AblyTokenDtoFromJSON(json) {
    return AblyTokenDtoFromJSONTyped(json, false);
}
function AblyTokenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keyName': json['keyName'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'ttl': json['ttl'] == null ? undefined : json['ttl'],
        'capability': json['capability'],
        'timestamp': json['timestamp'],
        'nonce': json['nonce'],
        'mac': json['mac'],
    };
}
function AblyTokenDtoToJSON(json) {
    return AblyTokenDtoToJSONTyped(json, false);
}
function AblyTokenDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'keyName': value['keyName'],
        'clientId': value['clientId'],
        'ttl': value['ttl'],
        'capability': value['capability'],
        'timestamp': value['timestamp'],
        'nonce': value['nonce'],
        'mac': value['mac'],
    };
}
